/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Viewmoreresources2Inputs */

const en_settings_viewmoreresources2 = /** @type {(inputs: Settings_Viewmoreresources2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View more resources`)
};

/**
* | output |
* | --- |
* | "View more resources" |
*
* @param {Settings_Viewmoreresources2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_viewmoreresources2 = /** @type {((inputs?: Settings_Viewmoreresources2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Viewmoreresources2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_viewmoreresources2(inputs)
});
export { settings_viewmoreresources2 as "settings_viewMoreResources" }